import TabButton from "components/atoms/buttons/TabButton";
import clsx from "clsx";
import { useState } from "react";
import HintIconWithTooltip from "components/molecules/forms/HintIconWithTooltip";
import MagnetInteractions from "./MagnetInteractions";
import MagnetMementos from "./MagnetMementos";
import MagnetIncentives from "./MagnetIncentives";

function hint(currentStep: 0 | 1 | 2) {
  switch (currentStep) {
    case 0:
      return "Mementos: These are the benefits that are available to the holders of this Magnet. These may include Exclusive Content, Exclusive Coupon Codes or Merchandise drops.";
    case 1:
      return "Influence: These are activities wherein you get to engage with the Magnet and brand creators. You can indulge in audience polls and share requests created by brands and earn exclusive rewards out here!";
    case 2:
      return "Incentives: These are the various challenges with rewards associated that this program offers to Magnet owners engaging with the brand's influence opportunities.";
    default:
      return "!";
  }
}

function TabSection({
  currentStep,
  isMagnetOwnedByUser,
  pollsResponded = [],
  socialShareResponded = [],
  isCustomizedUIBrand = false,
}: {
  isCustomizedUIBrand?: boolean;
  currentStep: 0 | 1 | 2;
  isMagnetOwnedByUser: boolean;
  socialShareResponded?: string[];
  pollsResponded?: string[];
}) {
  switch (currentStep) {
    case 0:
      return <MagnetMementos isMagnetOwnedByUser={isMagnetOwnedByUser} />;
    case 1:
      return <MagnetInteractions />;
    case 2:
      return (
        <MagnetIncentives
          isCustomizedUIBrand={isCustomizedUIBrand}
          pollsResponded={pollsResponded}
          socialShareResponded={socialShareResponded}
        />
      );
    default:
      return null;
  }
}

function MagnetPublicProfileMementoInteraction({
  isCustomizedUIBrand = false,
  isMagnetOwnedByUser,
  pollsResponded = [],
  socialShareResponded = [],
}: {
  isCustomizedUIBrand?: boolean;
  isMagnetOwnedByUser: boolean;
  pollsResponded?: string[];
  socialShareResponded?: string[];
}) {
  const [currentStep, setCurrentStep] = useState<0 | 1 | 2>(0);

  return !isCustomizedUIBrand ? (
    <div className={clsx(!isCustomizedUIBrand && "aspect-w-10", " h-full rounded-2xl border border-secondary")}>
      <div className="flex flex-col pb-4 2xl:pb-8 ">
        <div className="relative my-4 mr-3 space-x-6 font-sora font-semibold 2xl:my-8 2xl:ml-2 2xl:mr-4 2xl:text-lg">
          <div className="absolute -top-2 right-0">
            <HintIconWithTooltip
              hintText={hint(currentStep)}
              direction="bottom"
              hintTextClassName="text-base max-w-[20rem] leading-snug"
            />
          </div>
          <TabButton
            label="Mementos"
            isActive={currentStep === 0}
            handleOnClick={() => {
              setCurrentStep(0);
            }}
          />
          {/* {isMagnetOwnedByUser && (  */}
          <TabButton label="Influence" isActive={currentStep === 1} handleOnClick={() => setCurrentStep(1)} />
          <TabButton label="Incentives" isActive={currentStep === 2} handleOnClick={() => setCurrentStep(2)} />
          {/* )} */}
        </div>
        <TabSection
          isCustomizedUIBrand={isCustomizedUIBrand}
          currentStep={currentStep}
          isMagnetOwnedByUser={isMagnetOwnedByUser}
          pollsResponded={pollsResponded}
          socialShareResponded={socialShareResponded}
        />
        )
      </div>
    </div>
  ) : (
    <div className="grid grid-cols-11 gap-2 [&>*]:h-[60vh] [&>*]:overflow-y-auto [&>*]:rounded-lg [&>*]:border-1 [&>*]:border-[#842572]">
      <div className=" col-span-6 scrollbar-hide">
        <h3 className="mx-8 my-4 font-medium">Education Bank</h3>
        <MagnetMementos isMagnetOwnedByUser={isMagnetOwnedByUser} isCustomizedUIBrand={isCustomizedUIBrand} />
      </div>
      <div className="col-span-3 scrollbar-hide">
        <h3 className="mx-8 my-4 font-medium">Surveys</h3>
        <MagnetInteractions isCustomizedUIBrand={isCustomizedUIBrand} />
      </div>
      <div className="col-span-2 scrollbar-hide">
        <h3 className="mx-8 my-4 font-medium">Benefits</h3>
        <MagnetIncentives
          pollsResponded={pollsResponded}
          socialShareResponded={socialShareResponded}
          isCustomizedUIBrand={isCustomizedUIBrand}
        />
      </div>
    </div>
  );
}
export default MagnetPublicProfileMementoInteraction;
